"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportModule = void 0;
var tslib_1 = require("tslib");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var errors_1 = require("../constants/errors");
var util_1 = require("../util");
var export_1 = require("../utils/export");
/**
 * Functions for working with reports
 */
var ReportModule = /** @class */ (function () {
    function ReportModule(xhr) {
        var _this = this;
        this.xhr = xhr;
        this.handleExportResultError = function (error) {
            if (_this.isApiResponseError(error) &&
                error.response.status === 400 &&
                error.responseBody.indexOf(errors_1.ERROR_RESTRICTED_CODE) !== -1) {
                return Promise.reject(tslib_1.__assign(tslib_1.__assign({}, error), { message: errors_1.ERROR_RESTRICTED_MESSAGE }));
            }
            return Promise.reject(error);
        };
    }
    /**
     * exportResult
     * request new result export
     * request new export of existing AFM execution
     *
     * @experimental
     * @param projectId - GoodData projectId
     * @param executionResult - report which should be exported
     * @param exportConfig - requested export options
     * @param pollingOptions - for polling (maxAttempts, pollStep)
     * @returns Resolves if export successfully,
     *                   Reject if export has error (network error, api error)
     */
    ReportModule.prototype.exportResult = function (projectId, executionResult, exportConfig, pollingOptions) {
        var _this = this;
        if (exportConfig === void 0) { exportConfig = {}; }
        if (pollingOptions === void 0) { pollingOptions = {}; }
        var requestPayload = {
            resultExport: {
                executionResult: executionResult,
                exportConfig: tslib_1.__assign(tslib_1.__assign({}, exportConfig), this.sanitizeExportConfig(exportConfig)),
            },
        };
        return this.xhr
            .post("/gdc/internal/projects/" + projectId + "/exportResult", { body: requestPayload })
            .then(function (response) { return response.getData(); })
            .then(function (data) {
            return util_1.handleHeadPolling(_this.xhr.get.bind(_this.xhr), data.uri, export_1.isExportFinished, pollingOptions);
        })
            .catch(this.handleExportResultError);
    };
    ReportModule.prototype.sanitizeExportConfig = function (exportConfig) {
        var afm = exportConfig.afm;
        if (afm && !isEmpty_1.default(afm.filters)) {
            var sanitizedAfm = tslib_1.__assign(tslib_1.__assign({}, afm), { filters: this.sanitizeFilters(afm.filters) });
            return tslib_1.__assign(tslib_1.__assign({}, exportConfig), { afm: sanitizedAfm });
        }
        return exportConfig;
    };
    ReportModule.prototype.isApiResponseError = function (error) {
        return error.response !== undefined;
    };
    ReportModule.prototype.sanitizeFilters = function (filters) {
        return filters ? compact_1.default(filters) : [];
    };
    return ReportModule;
}());
exports.ReportModule = ReportModule;
//# sourceMappingURL=report.js.map